var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconEdit = function SvgIconEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.496,
    height: 19.992,
    viewBox: "0 0 22.496 19.992",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.724,3.252l3.523,3.523a.382.382,0,0,1,0,.539l-8.53,8.53-3.624.4a.76.76,0,0,1-.84-.84l.4-3.624,8.53-8.53A.382.382,0,0,1,15.724,3.252Zm6.327-.894L20.145.452a1.527,1.527,0,0,0-2.156,0L16.606,1.835a.382.382,0,0,0,0,.539L20.129,5.9a.382.382,0,0,0,.539,0L22.05,4.514a1.527,1.527,0,0,0,0-2.156ZM15,13.524V17.5H2.5V5h8.975a.48.48,0,0,0,.332-.137L13.369,3.3a.469.469,0,0,0-.332-.8H1.875A1.875,1.875,0,0,0,0,4.377V18.125A1.875,1.875,0,0,0,1.875,20H15.622A1.875,1.875,0,0,0,17.5,18.125V11.962a.47.47,0,0,0-.8-.332l-1.562,1.562A.48.48,0,0,0,15,13.524Z",
    transform: "translate(0 -0.007)",
    fill: "#8d8585"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-edit.5e2f5c79.svg";
export { ForwardRef as ReactComponent };